import {
  type AdminTeamMember,
  type CreateAdminBody,
  type DisableAdminBody,
  type InvitedAdmin,
} from '@/contracts';

import { authenticated } from '../auth-client';
import { API_PREFIX } from '../http';

export const adminsEndpoints = {
  /** The admin team — who reviews letters and audits documents (C5). */
  admins() {
    return authenticated<AdminTeamMember[]>(`${API_PREFIX}/admin/admins`);
  },

  /** Invites a teammate. The response carries a one-time password, shown once. */
  inviteAdmin(body: CreateAdminBody) {
    return authenticated<InvitedAdmin>(`${API_PREFIX}/admin/admins`, { method: 'POST', body });
  },

  /** Disables an account — reason is required and goes to the audit log (C5). */
  disableAdmin(adminId: string, reason: string) {
    const body: DisableAdminBody = { reason };
    return authenticated<AdminTeamMember>(`${API_PREFIX}/admin/admins/${adminId}/disable`, {
      method: 'POST',
      body,
    });
  },
};
